module.exports = __webpack_public_path__ + "img/ffc.64847913.png";